import './index.css';
import { cloneElement } from 'react';

const useDropButtons = ({ selectFileButton: _selectFileButton, deleteFileButton: _deleteFileButton, replaceImageButton: _replaceImageButton, onFileDelete, }) => {
    const selectFileButton = _selectFileButton &&
        cloneElement(_selectFileButton, {
            key: 'selectFileButton',
            'data-qa': 'magritte-select-file-button',
        });
    const deleteFileButton = _deleteFileButton &&
        cloneElement(_deleteFileButton, {
            key: 'deleteFileButton',
            'data-qa': 'magritte-delete-file-button',
            onClick: onFileDelete,
        });
    const replaceImageButton = _replaceImageButton &&
        cloneElement(_replaceImageButton, {
            key: 'replaceImageButton',
            'data-qa': 'magritte-select-replace-image-button',
        });
    return { selectFileButton, deleteFileButton, replaceImageButton };
};

export { useDropButtons };
//# sourceMappingURL=useDropButtons.js.map
